export default __webpack_public_path__ + "static/media/fastrewind01.00fecd49.svg";